import { Icon } from '@/shared/ui/atoms/Icon';
import './Checkbox.styl';

type Props = {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  strike?: boolean;
  className?: string;
  disabled?: boolean;
};

export function Checkbox({ checked, onChange, label, strike = false, className, disabled = false }: Props) {
  const classes = ['a-check'];
  if (checked) classes.push('a-check--on');
  if (strike) classes.push('a-check--strike');
  if (disabled) classes.push('a-check--disabled');
  if (className) classes.push(className);
  return (
    <label className={classes.join(' ')}>
      <input
        type="checkbox"
        className="a-check__input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="a-check__box" aria-hidden="true">
        {checked ? <Icon name="check" size={11} strokeWidth={2.4} /> : null}
      </span>
      <span className="a-check__label">{label}</span>
    </label>
  );
}
